export default "__VITE_ASSET__c313047c__"